/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { STATUS_COMPLETED, STATUS_CREATED, STATUS_DATA_COMPLETED, STATUS_LAWSUIT_COMPLETED, STATUS_WAITING_FOR_FEEDBACK } from "../litigationCase/leadStatus";
import { APPLICATION_STATUS_SUMMARY } from "./applicationStatus";
import React from "react";
import { getCaseLink, getProductData } from "../productService";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import { getButton, getContent, getPercentage } from "../litigationCase/statusBoxSteps";
import { ExtraContent } from "../litigationCase/StatusBox/ExtraContent";

const getContentContractLaw = (contractLawCase: AbstractCase) => {
  switch (contractLawCase.caseCategory) {
    case "advisory":
      switch (contractLawCase.leadStatus) {
        case STATUS_COMPLETED:
          if (contractLawCase.insurance.specialTermsTag === "advocardFlex") {
            if (contractLawCase.finalClaimStatusClient === null) {
              return {
                header: "Erstberatung abgeschlossen",
                text: "Vielen Dank für Ihr Vertrauen und dafür, dass wir Sie unterstützen durften! Sie sind der Meinung, dass nach Ihrer Erstberatung noch weitere rechtliche Schritte notwendig sind? Dann klicken Sie bitte hier auf “Weitere Tätigkeit notwendig”",
                buttonTarget: getCaseLink(contractLawCase) + "/flex/rueckmeldung",
                buttonLabel: "Weitere Tätigkeit notwendig",
              };
            } else {
              return {
                header: "Erstberatung abgeschlossen",
                text: "Vielen Dank für Ihr Vertrauen und dafür, dass wir Sie unterstützen durften!",
              };
            }
          } else {
            return {
              header: "Ihr Fall ist abgeschlossen",
              text: "Vielen Dank für Ihr Vertrauen und dafür, dass wir Sie unterstützen durften! Sie sind der Meinung, dass ihr Fall nicht abgeschlossen ist oder es sind im Nachgang doch noch Probleme aufgetreten? Dann schreiben Sie uns gerne jederzeit eine Nachricht und wir werden selbstverständlich umgehend für Sie tätig!",
            };
          }
        default:
          return getContent(contractLawCase);
      }
    default:
      switch (contractLawCase.leadStatus) {
        case STATUS_CREATED:
          if (contractLawCase.applicationStatus > APPLICATION_STATUS_SUMMARY) {
            return {
              header: "Ihre Vollmacht wird benötigt",
              text: "Um Ihren Fall zu prüfen und Ihr Anliegen als Ihr gesetzlicher Vertreter durchsetzen zu können, benötigen wir noch Ihre Vollmacht.",
              buttonTarget: getCaseLink(contractLawCase) + "/antrag",
              buttonLabel: "Zur Vollmacht",
            };
          }
          if (contractLawCase.name === "dataLeakContract") {
            return {
              header: "Kurz Fall schildern und prüfen lassen",
              text: contractLawCase.powerOfAttorney
                ? "Bitte ergänzen Sie kurz Angaben zu Ihrem Mobilfunkvertrag und Ihrer Versicherung, damit wir Schadensersatz für Sie erwirken können."
                : "Sie machen Angaben zu Ihrem Mobilfunk-Vertrag und erteilen uns die Vollmacht, damit wir Schadensersatz für Sie erwirken können.",
              buttonLabel: "Jetzt Fall schildern",
              buttonTarget: getCaseLink(contractLawCase) + "/antrag",
            };
          }
          return {
            header: "Fall schildern und Vorgehen festlegen",
            text: "Sie entscheiden, ob Sie nur eine kurze Beratung benötigen, oder wir direkt für Sie tätig werden sollen - zum Beispiel durch ein Schreiben an die Gegenseite. Sie wünschen eine rechtliche Vertretung durch uns? Dann können Sie hier auch direkt Ihre Vollmacht unterzeichnen.",
            buttonTarget: getCaseLink(contractLawCase) + "/antrag",
            buttonLabel: "Weiteres Vorgehen festlegen",
          };
        case STATUS_DATA_COMPLETED:
        case STATUS_WAITING_FOR_FEEDBACK:
          if (contractLawCase.name === "dataLeakContract") {
            return {
              header: "Ihre Angaben sind vollständig",
              text:
                "Wenn die Datenkopie vorliegt, prüfen wir zunächst Ihren Anspruch und werden dann die Kostendeckung" +
                " mit der Rechtsschutzversicherung klären und uns an den Mobilfunkanbieter wenden, um Schadensersatz für" +
                " Sie zu erwirken. Ihrerseits ist nichts weiter zu tun, außer etwas Geduld zu haben. Denn das Vorgehen " +
                "dauert erfahrungsgemäß mehrere Monate. Wichtig: Es besteht für Sie zu keiner Zeit ein Kostenrisiko! " +
                "Sollte die Versicherung Ihr Anliegen nicht decken wollen, versuchen wir alles, um doch eine Deckung zu " +
                "erwirken. Wenn die Deckung schlussendlich trotzdem verwehrt werden sollte, wird der Fall unserseits " +
                "abgeschlossen und es kommen keine Kosten auf Sie zu!",
            };
          }
          return {
            header: "Ihre Angaben sind vollständig",
            text: "Vielen Dank für die Schilderung Ihres Falls. Wir prüfen nun Ihren Fall und leiten zeitnah weitere Schritte für Sie ein!",
          };
        case STATUS_LAWSUIT_COMPLETED:
          return {
            header: "Der Rechtsstreit wurde beendet",
            text: contractLawCase.nextInstanceCaseBaseData
              ? "Ihr Vertragsrechtsfall ist in dieser Instanz beendet. Der Rechtsstreit wird in der nächsthöheren Instanz fortgesetzt. Sie finden dazu einen eigenständigen Fall in Ihrer Servicewelt."
              : "Ihr Vertragsrechtsfall wurde im gerichtlichen Verfahren entschieden. Wenn keine Partei das Ergebnis anfechtet, ist es rechtskräftig und Sie und die Gegenpartei müssen der Entscheidung des Gerichts Folge leisten.",
          };
        default:
          return getContent(contractLawCase);
      }
  }
};

export const getStatusBoxConfigContractLawCase = (contractLawCase: AbstractCase) => {
  const content = getContentContractLaw(contractLawCase);
  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(contractLawCase),
    productName: getProductData(contractLawCase.name, "label"),
    percentage: getPercentage(contractLawCase),
    extraContent: <ExtraContent litigationCase={contractLawCase} />,
  };
};
